// Home页面相关的类型定义和枚举

export const enum QuickActionType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
  TRANSFER = 'transfer',
  EXCHANGE = 'exchange'
}

export const enum BalanceDisplayMode {
  VISIBLE = 'visible',
  HIDDEN = 'hidden'
}

export const enum ButtonActionType {
  Deposit = 'deposit',
  Remittance = 'remittance',
  Exchange = 'exchange',
  More = 'more'
}

export interface QuickAction {
  type: QuickActionType
  label: string
  icon: string
  route: string
}

export interface BalanceInfo {
  total: string
  currency: string
  change24h: string
  displayMode: BalanceDisplayMode
}


export interface ButtonItem {
  actionType: ButtonActionType
  icon: string
  text: string
}

/**
 * KYC状态
 * wait_audit: 待审核
 * pass_audit: 审核通过
 * reject: 审核拒绝
 */
export const enum KYCStatus {
  WaitAudit = 'wait_audit',
  PassAudit = 'pass_audit',
  Reject = 'reject'
}